import { OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from '../../../core/environment/environment.service';
import { SessionService } from '@app/core/session/session.service';
var ContextButtonComponent = /** @class */ (function () {
    function ContextButtonComponent(environmentService, translate, _window, sessionService) {
        this.environmentService = environmentService;
        this.translate = translate;
        this._window = _window;
        this.sessionService = sessionService;
    }
    ContextButtonComponent.prototype.ngOnInit = function () {
        this.currentContext = 0;
    };
    ContextButtonComponent.prototype.onClickChangeContext = function (i) {
        this.currentContext = i;
        if (this.currentContext == 1) {
            this.sessionService.updateSession().subscribe(function () { });
            var url = this.environmentService.envModel.appSettings.fundsLiabilitiesUrl;
            this._window.open(url, "Passivo de Fundos", 'width=800,height=600');
        }
    };
    return ContextButtonComponent;
}());
export { ContextButtonComponent };
